import { useCloseModal, useShowModal } from '@/atoms'

import { modalId } from '../hooks/useController'
import { Root } from './Root'

export const useOutOfStorageSpaceModal = () => ({
  show: useShowModal(modalId),
  close: useCloseModal(),
  Modal: Root,
})
